import { Box, IconButton, Stack, TextField, Typography } from '@mui/material';

import { Icon } from '@karehero/llama/components/atoms/Icon/Icon';

import StatusBar from '@/designs-dev/device/StatusBar';
import ModalScreen from '@/designs-dev/device/ModalScreen';
import ScreenRoot from '@/components/wrapped/ScreenRoot';
import AppBar from '@/karehero-app/shell/AppBar';
import Body from '@/karehero-app/shell/Body';
import { HELP } from '@/karehero-app/help/Help.content';

// Talk to us: Intercom's messenger, rising over the tab. A stand-in so the
// prototype has somewhere to go. Intercom draws the real one, so this is only
// its shape: who you're talking to, their first message, and a box to reply in.
const HelpChat = ({ onClose }: { onClose: () => void }) => (
  <ModalScreen onClose={onClose}>
    {(close) => (
      <ScreenRoot>
        <StatusBar />
        <AppBar
          title={HELP.chat.title}
          subtitle={HELP.chat.replies}
          align='left'
          action={
            <IconButton
              aria-label={HELP.chat.close}
              size='small'
              onClick={close}
            >
              <Icon icon='xmark' fontSize={18} />
            </IconButton>
          }
        />
        <Body>
          <Box
            sx={{
              alignSelf: 'flex-start',
              maxWidth: '80%',
              px: 2,
              py: 1.5,
              borderRadius: '12px',
              bgcolor: 'custom.neutral.100',
            }}
          >
            <Typography variant='body2'>{HELP.chat.greeting}</Typography>
          </Box>
        </Body>
        <Stack
          direction='row'
          spacing={1}
          sx={{ px: 2, py: 1.5, alignItems: 'center' }}
        >
          <TextField
            size='small'
            fullWidth
            placeholder={HELP.chat.placeholder}
          />
          <IconButton aria-label={HELP.chat.send}>
            <Icon icon='paper-plane-top' fontSize={18} />
          </IconButton>
        </Stack>
      </ScreenRoot>
    )}
  </ModalScreen>
);

export default HelpChat;
